import { ScopeStreams } from '@shared/app/scripts/services/scope-streams';
import wrapInSafeApplyFactory from '@global/wrap-in-safe-apply';

import { includes } from 'lodash';
import { filter, takeUntil } from 'rxjs/operators';

/**
 * A directive that triggers a callback function, everytime when a key is released.
 * keydown events are global, and provided by {@link coreModule.keyStreams}
 *
 * # Attributes
 * sw-keydown - callback function
 * key - expression that evaluates to key value (letters)
 *
 * if the key attribute is missing, we default to listening to all keydown events
 *
 * # Examples
 * {@link https://core.dev.swcloud.nl/#/reusable-components/keydown interactive example}
 * <pre>
 *   <div sw-keydown="action()" key="'a'"></div>
 * </pre>
 * calls `action()` every time when key 'a' (case sensitive) is released

 * <pre>
 *   <div sw-keydown="action()"></div>
 * </pre>
 * calls `action()` every time when *any* key is pressed
 */
angular
  .module('coreModule')
  .directive(
    'swKeydown',
    ($parse: ng.IParseService, scopeStreams: ScopeStreams, keyStreams) => {
      return function (scope, element, attrs) {
        const keyParser = $parse(attrs.key),
          swKeydown = $parse(attrs.swKeydown),
          wrapInSafeApply = wrapInSafeApplyFactory(scope);

        keyStreams.keydown$
          .pipe(
            filter((event: KeyboardEvent) => {
              const keyValue = keyParser(scope);

              if (angular.isArray(keyValue)) {
                return includes(keyValue, event.key);
              } else if (keyValue) {
                return keyValue === event.key;
              } else {
                return true;
              }
            }),
            takeUntil(scopeStreams.isDestroyed(scope)),
          )
          .subscribe(
            wrapInSafeApply(() => {
              scope.$eval(swKeydown);
            }),
          );
      };
    },
  );
